var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoCanceled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.97345C2 9.42157 2 9.14563 2.07403 8.89151C2.1396 8.66641 2.24737 8.4547 2.39203 8.26677C2.55534 8.05461 2.78202 7.8852 3.23539 7.54638L10.0177 2.4777C10.369 2.21514 10.5447 2.08386 10.7387 2.03339C10.9098 1.98887 11.0902 1.98887 11.2613 2.03339C11.4553 2.08386 11.631 2.21514 11.9823 2.4777L18.7646 7.54638C19.218 7.8852 19.4447 8.05461 19.608 8.26677C19.7526 8.4547 19.8604 8.66641 19.926 8.89151C20 9.14563 20 9.42157 20 9.97345V16.9252C20 18.0015 20 18.5396 19.782 18.9507C19.5903 19.3123 19.2843 19.6063 18.908 19.7905C18.4802 20 17.9201 20 16.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.7905C2.71569 19.6063 2.40973 19.3123 2.21799 18.9507C2 18.5396 2 18.0015 2 16.9252V9.97345Z",
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_191040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.84L13.0733 14.58C13.1833 14.69 13.3233 14.745 13.4933 14.745C13.6633 14.745 13.8033 14.69 13.9133 14.58C14.0233 14.47 14.0783 14.33 14.0783 14.16C14.0783 13.99 14.0233 13.85 13.9133 13.74L12.1733 12L13.9133 10.26C14.0233 10.15 14.0783 10.01 14.0783 9.84C14.0783 9.67 14.0233 9.53 13.9133 9.42C13.8033 9.31 13.6633 9.255 13.4933 9.255C13.3233 9.255 13.1833 9.31 13.0733 9.42L11.3333 11.16L9.59334 9.42C9.48334 9.31 9.34334 9.255 9.17334 9.255C9.00334 9.255 8.86334 9.31 8.75334 9.42C8.64334 9.53 8.58834 9.67 8.58834 9.84C8.58834 10.01 8.64334 10.15 8.75334 10.26L10.4933 12L8.75334 13.74C8.64334 13.85 8.58834 13.99 8.58834 14.16C8.58834 14.33 8.64334 14.47 8.75334 14.58C8.86334 14.69 9.00334 14.745 9.17334 14.745C9.34334 14.745 9.48334 14.69 9.59334 14.58L11.3333 12.84ZM11.3333 18C10.5033 18 9.72334 17.8424 8.99334 17.5272C8.26334 17.212 7.62834 16.7846 7.08834 16.245C6.54834 15.705 6.12094 15.07 5.80614 14.34C5.49134 13.61 5.33374 12.83 5.33334 12C5.33334 11.17 5.49094 10.39 5.80614 9.66C6.12134 8.93 6.54874 8.295 7.08834 7.755C7.62834 7.215 8.26334 6.7876 8.99334 6.4728C9.72334 6.158 10.5033 6.0004 11.3333 6C12.1633 6 12.9433 6.1576 13.6733 6.4728C14.4033 6.788 15.0383 7.2154 15.5783 7.755C16.1183 8.295 16.5459 8.93 16.8611 9.66C17.1763 10.39 17.3337 11.17 17.3333 12C17.3333 12.83 17.1757 13.61 16.8605 14.34C16.5453 15.07 16.1179 15.705 15.5783 16.245C15.0383 16.785 14.4033 17.2126 13.6733 17.5278C12.9433 17.843 12.1633 18.0004 11.3333 18ZM11.3333 16.8C12.6733 16.8 13.8083 16.335 14.7383 15.405C15.6683 14.475 16.1333 13.34 16.1333 12C16.1333 10.66 15.6683 9.525 14.7383 8.595C13.8083 7.665 12.6733 7.2 11.3333 7.2C9.99334 7.2 8.85834 7.665 7.92834 8.595C6.99834 9.525 6.53334 10.66 6.53334 12C6.53334 13.34 6.99834 14.475 7.92834 15.405C8.85834 16.335 9.99334 16.8 11.3333 16.8Z",
    fill: "url(#paint0_linear_415_191040)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_191040",
    x: 4.33334,
    y: 5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_191040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_191040",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_191040",
    x1: 5.33334,
    y1: 6,
    x2: 17.5383,
    y2: 6.21218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoCanceled);
export default __webpack_public_path__ + "static/media/OneoCanceled.8650ef7d08e44e110a9d9585c75aca99.svg";
export { ForwardRef as ReactComponent };